import axiosInstance from './interceptor'

export const internalLogin = async (params: any) => {

    return await axiosInstance.post('/auth', params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const externalLogin = async (params: any) => {

    return await axiosInstance.post('/authexternalUser', params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const userData = async (id: any) => {

    return axiosInstance.get(`/User/GetUserByID/${id}`)
        .then(res => {
            return res
        })
        .catch(err => {
            return err;
        })
}
export const userforgotPassword = async (userName: any) => {

    return await axiosInstance.post(`/account/forgot-password?email=${userName}`, null).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}
export const validateOtp = async (otp: any) => {

    return await axiosInstance.post(`/account/validate-reset-token?token=${otp}`, null).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const userResetPassword = async (params: any) => {

    return await axiosInstance.post(`/account/reset-password`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const updatePassword = async (params: any) => {

    return await axiosInstance.put(`/Registration/UpdatePassword`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const LogoutApi = async () => {

    return await axiosInstance.post('/logout').then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}
